import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavbarToggler,
  NavItem,
  Container,
  Collapse,
} from "reactstrap";
import { Link } from "react-router-dom";

import logo from "../../assets/images/logo-circular-light-200x200.webp";

class SecundaryNavbarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMenu: false,
      isMobile: window.innerWidth <= 991,
      isScrolled: false,
    };
    this.toggle = this.toggle.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isScrolled = window.scrollY > 50;
    if (isScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled });
    }
  };

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth <= 991,
    });
  };

  toggle = () => {
    this.setState((prevState) => ({ isOpenMenu: !prevState.isOpenMenu }));
  };

  closeMenu = () => {
    this.setState({ isOpenMenu: false });
  };

  renderBreadcrumbs() {
    const { breadcrumbs = [] } = this.props;
    if (!breadcrumbs.length) return null;

    return (
      <nav aria-label="Miga de pan" className="navbar-breadcrumbs">
        {breadcrumbs.map((crumb, idx) => (
          <span key={`${crumb.label}-${idx}`}>
            {crumb.href ? (
              <Link to={crumb.href}>{crumb.label}</Link>
            ) : (
              <span className="current" aria-current="page">
                {crumb.label}
              </span>
            )}
            {idx < breadcrumbs.length - 1 && <span aria-hidden="true"> / </span>}
          </span>
        ))}
      </nav>
    );
  }

  render() {
    const { isMobile, isScrolled } = this.state;
    const { companyName = "Seguridad al Límite", navItems = [] } = this.props;
    const hasMenuItems = navItems.length > 0;

    return (
      <Navbar
        expand="lg"
        fixed={this.props.top === true ? "top" : ""}
        className={`${this.props.navClass} navbar-custom navbar-secondary sticky sticky-dark px-4 ${isScrolled ? "is-scrolled" : ""}`}
        id="navbar"
      >
        <Container className="position-relative">
          <div className="d-flex align-items-center w-100">
            <Link
              to="/"
              className="navbar-brand-logo"
              aria-label={`${companyName} - Inicio`}
            >
              <img
                src={logo}
                alt={`Logo ${companyName}`}
                width="44"
                height="44"
                loading="eager"
              />
              <span className="navbar-brand-name d-none d-md-inline">
                {companyName}
              </span>
            </Link>

            {hasMenuItems && (
              <NavbarToggler
                onClick={this.toggle}
                className="border-0 ms-auto d-lg-none"
                aria-label={this.state.isOpenMenu ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
                aria-expanded={this.state.isOpenMenu}
              >
                <i
                  className={`mdi ${this.state.isOpenMenu ? "mdi-close" : "mdi-menu"} text-white`}
                  aria-hidden="true"
                ></i>
              </NavbarToggler>
            )}

            <Collapse isOpen={this.state.isOpenMenu} navbar className="mobile-menu">
              <Nav
                className={`${isMobile ? "flex-column" : ""} mx-auto align-items-center`}
                navbar
              >
                {navItems.map((item) => (
                  <NavItem
                    key={item.id}
                    className={isMobile ? "w-100 text-center mb-2" : ""}
                  >
                    <Link
                      to={item.to}
                      className="nav-link"
                      onClick={this.closeMenu}
                    >
                      {item.navheading}
                    </Link>
                  </NavItem>
                ))}
              </Nav>

              <div className={`navbar-cta ${isMobile ? "navbar-cta--mobile" : ""}`}>
                <a
                  href="https://cursos.seguridadallimite.com/#/student/inscription"
                  className={`btn btn-primary amarillo ${isMobile ? "w-100 mb-2" : "me-2"}`}
                  onClick={this.closeMenu}
                >
                  Inscríbete
                </a>
                <a
                  href="https://cursos.seguridadallimite.com/#/student/certificate"
                  className={`btn btn-primary amarillo ${isMobile ? "w-100" : ""}`}
                  onClick={this.closeMenu}
                >
                  Certificados
                </a>
              </div>
            </Collapse>
          </div>
          {this.renderBreadcrumbs()}
        </Container>
      </Navbar>
    );
  }
}

export default SecundaryNavbarPage;
